import React from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import { PulseLoader } from "react-spinners";
import { toast } from "react-toastify";
import { rejectKyc } from "../../../redux/features/kycSlice";
// import your actual rejectKyc action

interface ConfirmRejectKycModalProps {
  isOpen: boolean;
  onClose: () => void;
  userId: string;
  kycStatus: string;
  onRejected?: () => void;
}

const ConfirmRejectKycModal: React.FC<ConfirmRejectKycModalProps> = ({
  isOpen,
  onClose,
  userId,
  onRejected,
  kycStatus,
}) => {
  const { rejecting } = useAppSelector((state) => state.kyc); // or wherever your state is
  const dispatch = useAppDispatch();

  const handleReject = async () => {
    try {
      await dispatch(
        rejectKyc({ userId, status: kycStatus, verified: false })
      ).unwrap();
      onRejected?.();
      onClose();
    } catch (error: any) {
      toast.error(error?.message ?? "Failed to reject KYC.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white w-full max-w-md rounded-lg p-6 shadow-lg">
        <div className="flex justify-center mb-4">
          <div className="bg-red-100 text-red-600 rounded-full p-4">❌</div>
        </div>
        <h2 className="text-center text-xl font-semibold mb-2">Reject KYC</h2>
        <p className="text-center text-gray-600 mb-6">
          Are you sure you want to reject this user's KYC?
        </p>
        <div className="flex justify-between">
          <button
            onClick={onClose}
            className="w-1/2 bg-gray-100 text-gray-800 rounded-md py-2 px-4 mr-2 hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            onClick={handleReject}
            className="w-1/2 bg-red-600 text-white rounded-md py-2 px-4 hover:bg-red-700"
          >
            {rejecting ? <PulseLoader size={6} color="#fff" /> : "Yes, Reject"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmRejectKycModal;
